export default __webpack_public_path__ + "static/media/cover.6f4d3a2b.jpeg";